var exports = {
  "wx": "xcc377c0b--62aa4b--header",
  "Zp": "xcc377c0b--62aa4b--layout",
  "Qs": "xcc377c0b--62aa4b--content",
  "DD": "xcc377c0b--62aa4b--title",
  "O0": "xcc377c0b--62aa4b--rating",
  "tJ": "xcc377c0b--62aa4b--title-name",
  "ne": "xcc377c0b--62aa4b--controls",
  "wM": "xcc377c0b--62aa4b--secondary-controls",
  "hR": "xcc377c0b--62aa4b--message-button",
  "C$": "xcc377c0b--62aa4b--nav",
};

module.exports = exports;
